import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { DisplayIcon } from './DisplayIcon';
import PropTypes from 'prop-types';

const DisplaySummary = ({ messageType, documentMessages, disabled }) => {
  const { t } = useTranslation();
  const filteredWarnings = documentMessages.filter(x => x.messageType === messageType);

  const errorMessage = useMemo(() => {
    let errorMessage = '';
    switch (messageType) {
      case 'Info':
        return (errorMessage = t('General.DocumentMessages.Info'));
      case 'Warning':
        return (errorMessage = t('General.DocumentMessages.Warnings'));
      case 'Error':
        return (errorMessage = t('General.DocumentMessages.Errors'));
      default:
        return errorMessage;
    }
  }, [messageType, t]);

  return (
    <Grid container justifyContent='center' alignItems='center' sx={{ gap: 1 }}>
      <DisplayIcon messageType={messageType} disabled={disabled} />
      <span>{`${filteredWarnings.length} ${errorMessage}`}</span>
    </Grid>
  );
};

DisplaySummary.propTypes = {
  documentMessages: PropTypes.array,
  messageType: PropTypes.string,
  disabled: PropTypes.bool
};

export default DisplaySummary;
